mutation ResetUserNotificationCount($input: MessageResetUserNotificationCountInput!) {
  messageResetUserNotificationCount(input: $input) {
    query {
      userNotificationUnreadCounts
    }
  }
}